import trpc from "@/shared/utils/trpc";
import { Flex, Text, Title, Button } from "@mantine/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Maintenance = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trpc.maintenance.get.query().then((maintenanceList) => {
      if (!maintenanceList?.webMaintenanceEnabled) {
        navigate("/login", { replace: true });
      }
    });
  }, [navigate]);

  const handleGoBack = () => {
    // If there is history, go back
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback route
      navigate("/login");
    }
  };

  return (
    <Flex direction="column" justify="center" align="center" h="100vh">
      <Flex mb={40} align="center">
        <Title ml={12}>Global Tech</Title>
      </Flex>

      <Flex direction="column" justify="center" align="center" mt={20} gap={12} w={550}>
        <Title order={2} c="#475569">
          Global Tech portal is under maintenance
        </Title>

        <Text c="#475569" ta="center">
          We are doing some maintenance to improve your experience. The portal will be back shortly. Thanks for your
          patience.
        </Text>

        <Button mt={20} variant="outline" color="gray" onClick={handleGoBack}>
          Go back
        </Button>
      </Flex>
    </Flex>
  );
};

export default Maintenance;
